// extracted by mini-css-extract-plugin
export default {"form-container-head-warning":"Table_form-container-head-warning__hHBRX","buttons":"Table_buttons__G5kg6"};